export const messages = {
  ru: {
    title: 'Шаблоны WABA',
    status: 'Статус',
    filters: 'Фильтры',
    noResults: 'По вашему запросу ничего не найдено',
    subtitle:
      'Согласование и каталог WhatsApp. Привязка к сценариям — в «Шаблонах СУ».',
    create: 'Создать шаблон',
    sync: 'Обновить из Wazzup',
    back: 'К списку',
    save: 'Сохранить черновик',
    submit: 'Отправить на согласование',
    copy: 'Создать на основе',
    search: 'Поиск по названию или тексту',
    all: 'Все статусы',
    name: 'Название',
    category: 'Категория',
    language: 'Язык',
    source: 'Канал WhatsApp',
    choose: 'Выберите канал',
    body: 'Текст сообщения',
    footer: 'Подпись (необязательно)',
    header: 'Заголовок (необязательно)',
    utility: 'Уведомления',
    marketing: 'Маркетинг',
    buttons: 'Кнопки',
    addButton: 'Добавить кнопку',
    reply: 'Быстрый ответ',
    url: 'Ссылка',
    label: 'Текст кнопки',
    remove: 'Убрать',
    example: 'Пример для переменной {number}',
    variableHint:
      'Используйте переменные вида {example}. Для согласования заполните примеры вымышленными данными.',
    preview: 'Предпросмотр',
    empty: 'Шаблонов пока нет. Загрузите их из Wazzup.',
    loading: 'Загрузка…',
    unavailable: 'Этот шаблон недоступен подключённому каналу',
    unsupported:
      'Шаблон отображается полностью. Привязка пока недоступна: отправитель не поддерживает этот тип заголовка или кнопок.',
    auth: 'Для согласования требуется партнёрская авторизация Wazzup. Импорт и сохранение черновиков доступны.',
    readonly:
      'Текст импортированного шаблона защищён. Для изменений создайте новый на его основе.',
    reason: 'Причина отклонения',
    updated: 'Синхронизировано',
    saved: 'Черновик сохранён',
    synced: 'Каталог обновлён',
    sent: 'Шаблон передан на согласование',
    confirm:
      'Отправить «{name}» на модерацию Meta через Wazzup? Это реальное действие.',
    discard: 'Есть несохранённые изменения. Покинуть редактор?',
    required: 'Заполните название, канал и текст.',
    syncFirst: 'Сначала обновите каталог выбранного канала из Wazzup.',
    noSource: 'Нет подключённого источника Wazzup.',
    error: 'Не удалось выполнить действие',
    copyUnsupported:
      'Этот формат можно просмотреть здесь; для его редактирования используйте Wazzup.',
    statuses: {
      draft: 'Черновик',
      submitting: 'Отправляется',
      submission_unknown: 'Результат требует проверки',
      pending: 'На согласовании',
      approved: 'Одобрен',
      rejected: 'Отклонён',
      archived: 'Архивный',
      paused: 'Приостановлен',
      disabled: 'Заблокирован',
    },
    errors: {
      waba_management_not_connected:
        'Не подключена партнёрская авторизация Wazzup.',
      waba_not_draft: 'Можно отправить только новый сохранённый черновик.',
      waba_source_sync_required:
        'Сначала синхронизируйте шаблоны этого WABA-канала.',
      waba_examples_required:
        'Переменные должны идти от 1 без пропусков. Заполните пример для каждой.',
      waba_submission_unknown:
        'Ответ Wazzup не получен. Не отправляйте повторно: проверьте шаблон в Wazzup и обновите каталог.',
    },
  },
  en: {
    title: 'WABA templates',
    status: 'Status',
    filters: 'Filters',
    noResults: 'No matching templates',
    subtitle:
      'WhatsApp catalog and approval. Bind templates in Automation templates.',
    create: 'Create template',
    sync: 'Refresh from Wazzup',
    back: 'Back',
    save: 'Save draft',
    submit: 'Submit for approval',
    copy: 'Create a copy',
    search: 'Search title or text',
    all: 'All statuses',
    name: 'Name',
    category: 'Category',
    language: 'Language',
    source: 'WhatsApp channel',
    choose: 'Select channel',
    body: 'Message text',
    footer: 'Footer (optional)',
    header: 'Header (optional)',
    utility: 'Utility',
    marketing: 'Marketing',
    buttons: 'Buttons',
    addButton: 'Add button',
    reply: 'Quick reply',
    url: 'URL',
    label: 'Button label',
    remove: 'Remove',
    example: 'Example for variable {number}',
    variableHint:
      'Use variables such as {example}. Supply fictional examples for approval.',
    preview: 'Preview',
    empty: 'No templates. Import from Wazzup.',
    loading: 'Loading…',
    unavailable: 'Unavailable for connected channels',
    unsupported:
      'Displayed in full. Binding is unavailable: the sender does not support this header or button type.',
    auth: 'Approval requires Wazzup partner authorization. Import and local drafts remain available.',
    readonly: 'Imported content is locked. Create a new template to change it.',
    reason: 'Rejection reason',
    updated: 'Synced',
    saved: 'Draft saved',
    synced: 'Catalog refreshed',
    sent: 'Submitted for approval',
    confirm: 'Submit “{name}” to Meta through Wazzup? This is a real action.',
    discard: 'Discard unsaved changes?',
    required: 'Enter a name, channel and message.',
    syncFirst: 'Refresh the channel catalog first.',
    noSource: 'No Wazzup source connected.',
    error: 'Action failed',
    copyUnsupported: 'View this format here; edit it in Wazzup.',
    statuses: {
      draft: 'Draft',
      submitting: 'Submitting',
      submission_unknown: 'Needs verification',
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      archived: 'Archived',
      paused: 'Paused',
      disabled: 'Disabled',
    },
    errors: {
      waba_management_not_connected:
        'Wazzup partner authorization is not connected.',
      waba_not_draft: 'Only a new saved draft can be submitted.',
      waba_source_sync_required: 'Sync this WABA channel first.',
      waba_examples_required:
        'Use consecutive variables starting at 1 and fill all examples.',
      waba_submission_unknown:
        'No response from Wazzup. Check the provider and sync before retrying.',
    },
  },
};

export const statusClass = status =>
  ({
    approved: 'bg-n-teal-3 text-n-teal-11',
    rejected: 'bg-n-ruby-3 text-n-ruby-11',
    disabled: 'bg-n-ruby-3 text-n-ruby-11',
    pending: 'bg-n-amber-3 text-n-amber-11',
    submission_unknown: 'bg-n-amber-3 text-n-amber-11',
  })[status] || 'bg-n-alpha-2 text-n-slate-11';
